import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ITicket } from '../interfaces/ticket';
import { ITicketLocation } from '../interfaces/ticket-location';
import { TicketLocationApiService } from './ticket-location-api-service';

@Injectable()
export class TicketLocationDataSource extends DataSource<any> {
  public EventLocations: BehaviorSubject<ITicketLocation[]> =
    new BehaviorSubject([]);

  constructor(protected TicketLocationApi: TicketLocationApiService) {
    super();
  }

  public connect(
    collectionViewer?: CollectionViewer
  ): BehaviorSubject<ITicketLocation[]> {
    return this.EventLocations;
  }

  disconnect(collectionViewer: CollectionViewer): void {}

  public async List(listingId: string) {
    return await this.TicketLocationApi.list('listing-admin', listingId);
  }
  public async save(productId: string, ticketId: number, ticketData: any) {
    return await this.TicketLocationApi.save(
      'listing-admin',
      productId,
      ticketId,
      ticketData
    );
  }

  public async delete(productId: string, ticketId: number) {
    return await this.TicketLocationApi.delete(
      'listing-admin',
      productId,
      ticketId
    );
  }
}
